import { ArrowUturnLeftIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import MedicalRecordQueue from "../../components/medicalRecord/MedicalRecordQueue";

function MedicalRecords() {
  const navigate = useNavigate();
  const [showFilters, setShowFilters] = useState(false);

  return (
    <div className="p-2 sm:p-3 pb-20 min-h-[calc(100vh-1rem)] flex flex-col">
      <div className="bg-white rounded-lg shadow-sm border flex flex-col min-h-0 flex-1">
        <div className="sticky top-0 z-10 bg-white rounded-t-lg px-2 py-1 sm:px-3 sm:py-1.5 border-b border-gray-200 bg-gradient-to-r shadow-sm">
          <div className="flex items-center justify-between gap-2">
            <h2 className="text-sm sm:text-base font-semibold text-[#217E90] flex items-center gap-1 sm:gap-2">
              <button
                type="button"
                onClick={() => navigate(-1)}
                className="p-0.5 rounded hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-[#217E90]"
                aria-label="Go back"
              >
                <ArrowUturnLeftIcon className="h-4 w-4 sm:h-5 sm:w-5 flex-shrink-0" />
              </button>
              <span className="truncate">Medical Records</span>
            </h2>

            <button
              type="button"
              onClick={() => setShowFilters((s) => !s)}
              className="lg:hidden bg-[#217E90] text-white px-3 py-2 rounded-lg text-sm font-medium flex items-center justify-center gap-2 flex-shrink-0"
            >
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
                />
              </svg>
              {showFilters ? "Hide" : "Show"} Filters
            </button>
          </div>
        </div>

        <div className="p-2 sm:p-3 flex-1 min-h-0 overflow-y-auto space-y-3 sm:space-y-4">
          <MedicalRecordQueue
            hideTitle
            showFilters={showFilters}
            setShowFilters={setShowFilters}
            tableHeading="Medical record list"
          />
        </div>
      </div>
    </div>
  );
}

export default MedicalRecords;
